import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Badge = ({
    className,
    color,
    children
}) => {
    const classes = classNames(
        'Badge',
        `Badge-${color}`,
        className
    );

    return (
        <span className={classes}>
            {children}
        </span>
    );
};

Badge.propTypes = {
    className: PropTypes.string,
    children: PropTypes.string.isRequired,
    color: PropTypes.oneOf(['default', 'inverse', 'danger', 'warning', 'success', 'neutral'])
};

Badge.defaultProps = {
    color: 'default'
};

export default Badge;



// WEBPACK FOOTER //
// ./frontend/src/js/components/badge/Badge.jsx